// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { rolluxTestnet as _rolluxTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the rolluxTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 57000
 * Chain Name: Rollux Testnet
 * Default Block Explorer: https://rollux.tanenbaum.io
 * Default RPC URL: https://rpc-tanenbaum.rollux.com/
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { rolluxTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: rolluxTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const rolluxTestnet = createCommon({
	..._rolluxTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
